import { onDomReady } from "../../../assets/javascripts/utils.js";

const LABEL_SHOW = "Show more breadcrumb items";
const LABEL_HIDE = "Hide breadcrumb items";

const handleToggle = (event) => {
  const btn = event.currentTarget;
  const expanded = btn.getAttribute("aria-expanded") === "true";
  btn.setAttribute("aria-expanded", String(!expanded));
  btn.setAttribute("aria-label", expanded ? LABEL_SHOW : LABEL_HIDE);
};

onDomReady(() => {
  document.querySelectorAll(".em-breadcrumbs_toggle-btn").forEach((btn) => {
    btn.addEventListener("click", handleToggle);
  });
});
